module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-1-photo-3-29e65b2436c14193ed788660b7a02ad8.webp";